/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Box, useToast, Text, HStack, Image, Spacer } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAlertMessage,
  getAlertType,
  getAlertVisible,
} from "@root/store/selectors/features/alert";
import { hideAlert } from "@root/store/slices/features/alert";
import { TOAST_VARIANT, TOAST_VARIANT_COLORS } from "@root/constants/common";
import WarningIcon from "@root/assets/images/warning.svg";
import SuccessIcon from "@root/assets/images/success.svg";
import InfoIcon from "@root/assets/images/info.svg";
import CancelIcon from "@root/assets/images/cancel.svg";

export const AlertWrapper: React.FC<AlertWrapperProps> = ({ children }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const toastIdRef: allAnyTypes = React.useRef();
  const message = useSelector(getAlertMessage);
  const type: any = useSelector(getAlertType);
  const visible = useSelector(getAlertVisible);
  const renderIcon = () => {
    if (type === TOAST_VARIANT.ERROR) {
      return <Image boxSize={"16px"} src={WarningIcon} />;
    }
    if (type === TOAST_VARIANT.SUCCESS) {
      return <Image boxSize={"16px"} src={SuccessIcon} />;
    }
    if (type === TOAST_VARIANT.WARNING) {
      return <Image boxSize={"16px"} src={WarningIcon} />;
    }
    if (type === TOAST_VARIANT.INFO) {
      return <Image boxSize={"16px"} src={InfoIcon} />;
    }

    return null;
  };

  const handleClose = () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    dispatch(hideAlert());
  };

  useEffect(() => {
    if (visible) {
      const colors = TOAST_VARIANT_COLORS[type];
      if (!colors) {
        return;
      }
      const { borderColor, textColor, backgroundColor } = {
        borderColor: colors.borderColor ?? "#E2E8F0",
        textColor: colors.textColor ?? "#18191B",
        backgroundColor: colors.backgroundColor ?? "#FFFFFF",
      };

      toastIdRef.current = toast({
        description: message,
        status: type,
        position: "top-right",
        duration: 5000,
        render: () => (
          <Box borderRadius="md" bgColor={"#FFF"}>
            <Box
              color={textColor}
              bg={backgroundColor}
              minHeight={"40px"}
              py={"10px"}
              pl={"10px"}
              pr={"10px"}
              border="1px solid"
              borderColor={borderColor}
              borderRadius="md"
            >
              <HStack spacing={3} alignItems="flex-start">
                {renderIcon()}
                <Text
                  pl={"1px"}
                  fontWeight={400}
                  fontSize={"16px"}
                  lineHeight="1.5"
                  noOfLines={3}
                  wordBreak="break-word"
                  flex={1}
                  minWidth={0}
                >
                  {message}
                </Text>
                <Image
                  boxSize={"16px"}
                  src={CancelIcon}
                  onClick={handleClose}
                  cursor="pointer"
                  mt={"2px"}
                  flexShrink={0}
                />
              </HStack>
            </Box>
          </Box>
        ),
      });
    }

    setTimeout(() => {
      dispatch(hideAlert());
    }, 3000);
  }, [visible, type]);

  return <>{children}</>;
};
